module.exports = __webpack_public_path__ + "static/media/Mouser-Unselected.89d26113.png";